import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Response_Processing from "../../layout/Others/Response_Processing";
import { toast } from "react-toastify";
import AdminDeleteModal from "../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../components/CommonComponents/AdminNavbar";
import { IconDeleteFigma, IconEditFigma } from "../../Assets/MyIcons";
import { getItemToken } from "../../Utils/localStorageUtils";
import NoRecordTable from "../../components/CommonComponents/NoRecordTable";
import { FaEllipsisVertical } from "react-icons/fa6";
import MessageBox from "../../components/CommonComponents/MessageBox";
import { useMyContext } from "../../components/Provider/CommonProvider";

function Faq_category() {
  const { deleteImageFile } = useMyContext()
  const baseURL = process.env.REACT_APP_Baseurl;
  const headers = getItemToken("access_token");
  const labelSource = "faq-category";

  const deleteApi = `${baseURL}/admin/faq-genre/multi-delete`;
  const orderApi = `${baseURL}/admin/faq-genre/order`;
  const listApi = `${baseURL}/admin/faq-genre/index`;
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`;

  const [withOutRefresh, setWithOutRefresh] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalClose, setModalClose] = useState(false);
  const [selectAllData, setSelectAllData] = useState(false);
  const [itemDelete, setItemDelete] = useState([]);
  const [labelDisplay, setLabelDisplay] = useState([]);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = apiData?.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(apiData?.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage, itemsPerPage]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${listApi}`, { headers: headers });
      const result = response?.data?.AdminGenreFAQ;
      if (response?.data?.status) {
        setApiData(result);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const labelFetch = async () => {
    try {
      setShowOverlay(true);
      const response = await axios.get(`${labelApi}`, { headers: headers });
      setLabelDisplay(response?.data?.label_management);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setShowOverlay(false);
    }
  };
  const handleDeleteImage = async () => {
    await deleteImageFile(itemDelete, "GenreFaq");
  }

  const handleDelete = async () => {
    setShowOverlay(true);
    await handleDeleteImage();
    handleCloseModal();
    try {
      const response = await axios.delete(`${deleteApi}`, {
        headers: headers,
        data: { id: [...itemDelete] },
      });
      if (response?.data?.status) {
        toast.success(response?.data?.message);
        setWithOutRefresh(!withOutRefresh);
        setSelectAllData(false);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setShowOverlay(false);
    }
  };

  const saveShuffleOrder = async (updatedItems) => {
    setShowOverlay(true);
    const positions = updatedItems.map((menuItem) => menuItem?.id);
    const ids = updatedItems.map((_, index) => index + 1);
    const requestData = { id: positions, position: ids };
    try {
      const response = await axios.post(orderApi, requestData, {
        headers: headers,
      });
      if (response?.data?.status) {
        toast.success(response?.data?.message);
        setWithOutRefresh(!withOutRefresh);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setShowOverlay(false);
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reorderedItems = [...apiData];
    const [movedItem] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, movedItem);
    setApiData(reorderedItems);
    saveShuffleOrder(reorderedItems);
  };

  const handleSelectAllData = () => {
    setSelectAllData(!selectAllData);
    setItemDelete(selectAllData ? [] : currentItems.map((item) => item.id));
  };

  const handleSingleFile = (itemId) => {
    if (itemDelete.includes(itemId)) {
      setItemDelete(itemDelete.filter((id) => id !== itemId));
    } else {
      setItemDelete([...itemDelete, itemId]);
    }
  };

  const handleSingleDelete = (id) => {
    setItemDelete([id]);
    setModalClose(true);
    setSelectAllData(false);
  };

  const handleCloseModal = () => {
    setModalClose(false);
    setItemDelete([]);
  };

  const handleOpenDeleteModal = () => {
    setModalClose(true);
  };

  useEffect(() => {
    fetchData();
    labelFetch();
  }, [withOutRefresh]);

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modalClose && (
        <AdminDeleteModal
          modelClose={modalClose}
          deleteClose={handleCloseModal}
          deleteAction={handleDelete}
          buttonText={itemDelete?.length}
        />
      )}
      <AdminNavbar
        heading={labelDisplay?.[0]?.title}
        totalDataLength={apiData?.length}
        deleteCount={itemDelete?.length}
        navigation={"/add-faq-category"}
        deleteMethod={handleOpenDeleteModal}
        navText={labelDisplay?.[1]?.title}
      />
      <div className="theme-bg-color ">
        <div className="bootstrapTable theme-bg-color p-3 rounded-2">
          <div className="row m-0 theme-border-bottom-secondary pb-3">
            <div className="rowCheckboxDrag">
              <label>
                <input
                  type="checkbox"
                  checked={selectAllData}
                  onChange={handleSelectAllData}
                />
              </label>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-4">
              <label className="theme-text-color fw-bold fs-6">Category</label>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
              <label className="theme-text-color fw-bold fs-6">Actions</label>
            </div>
          </div>
        </div>

        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="menu-items">
            {(provided) => (
              <ul
                {...provided.droppableProps}
                ref={provided.innerRef}
                className=" px-0 theme-bg-color m-0 p-0 list-unstyled"
              >
                {loading ? (
                  <NoRecordTable result={0} loader={true} />
                ) : currentItems?.length <= 0 ? (
                  <NoRecordTable result={0} loader={false} />
                ) : (
                  currentItems.map((item, index) => (
                    <Draggable
                      key={item.id.toString()}
                      draggableId={item.id.toString()}
                      index={index + indexOfFirstItem}
                    >
                      {(provided) => (
                        <li
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="theme-bg-color theme-text-color w-100 theme-border-bottom-secondary px-3"
                        >
                          <div className="row m-0 p-0 align-items-center">
                            <div className="rowCheckboxDrag category-order-title">
                              <input
                                type="checkbox"
                                checked={itemDelete.includes(item.id)}
                                onChange={() => handleSingleFile(item.id)}
                              />
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-4 category-order-title">
                              <div className="d-flex justify-content-between align-items-center">
                                <img
                                  src={item?.image}
                                  className="profile"
                                  alt="faq"
                                />
                                <div className="rightVideoTitle">
                                  <span className="theme-text-color table-heading d-flex align-items-center">
                                    {item?.name.slice(0, 15)}...
                                  </span>
                                  <span className="dateText table-subheading">
                                    {item?.upload_on}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3 col-3 category-order-title">
                              <div className="editdropdown">
                                <span className="editdropdown-button">
                                  <FaEllipsisVertical className="theme-text-color" />
                                </span>
                                <div className="editdropdown-menu theme-bg-color">
                                  <Link
                                    to={`/edit-faq-category/${item?.id}`}
                                    className="theme-text-color theme-bg-color"
                                  >
                                    <span>
                                      <IconEditFigma styled={{ width: 20, height: 20 }} />
                                      <MessageBox
                                        text="Edit"
                                        classname="ms-2 theme-text-color"
                                      />
                                    </span>
                                  </Link>
                                  <div
                                    onClick={() => handleSingleDelete(item?.id)}
                                    className="commonActionPadding theme-bg-color"
                                  >
                                    <IconDeleteFigma styled={{ width: 20, height: 20 }} />
                                    <MessageBox
                                      text="Delete"
                                      classname="ms-2 theme-text-color"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                    </Draggable>
                  ))
                )}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>

        {/* Pagination */}
        {apiData?.length > 0 && (
          <div className="d-flex justify-content-between align-items-center flex-wrap px-4 py-3">
            <div className="d-flex align-items-center gap-2">
              <select
                className="form-select form-select-sm"
                value={itemsPerPage}
                onChange={(e) => {
                  setCurrentPage(1);
                  setItemsPerPage(Number(e.target.value));
                }}
                style={{ width: "70px" }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
              </select>
              <span className="theme-text-color small">
                Showing rows {indexOfFirstItem + 1} to{" "}
                {Math.min(indexOfLastItem, apiData.length)} of {apiData.length}
              </span>
            </div>

            <nav>
              <ul className="pagination mb-0 pagination-sm">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(1)}>
                    «
                  </button>
                </li>
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={handlePrevPage}>
                    Prev
                  </button>
                </li>
                <li className="page-item active">
                  <span className="page-link">{currentPage}</span>
                </li>
                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                  <button className="page-link" onClick={handleNextPage}>
                    Next
                  </button>
                </li>
                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                  <button className="page-link" onClick={() => setCurrentPage(totalPages)}>
                    »
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </>
  );
}

export default Faq_category;
